<template>
  <div>
    <section id="toggle-menu" v-bind:class="[isOpenMenu ? 'active' : ' ']">
      <div class="nav-list-wrap">
        <div class="nav-list-inner">
          <div class="sub-ui-2-depth">
            <div class="sub-ui-side">
              <ul class="sub-ui-side-list">
                <menu-tab
                  v-for="(item, index) in this.getMenuList"
                  v-bind:key="item.menu_id"
                  v-bind:item="item"
                  v-bind:tabindex="index"
                >
                </menu-tab>
              </ul>
            </div>
            <div class="sub-ui-wrap">
              <div
                class="sub-ui-c"
                v-for="(item, index) in this.getMenuList"
                v-bind:key="item.menu_id"
                :class="[index === 0 ? 'active' : ' ']"
                :id="getTabmenu(index)"
              >
                <h2>{{ item.menu_nm }}</h2>

                <ul class="explode-menu" v-if="item.menu_list.length">
                  <li
                    v-for="subitem in item.menu_list"
                    v-bind:key="subitem.menu_id"
                    :class="[subitem.menu_div_cd !== '00' ? '' : 'has-sub']"
                    :data-div_cd="subitem.menu_div_cd"
                    :data-pgmid="subitem.pgm_id"
                    :data-pgmurl="subitem.pgm_url"
                  >
                    <div class="btn-menu" @click="clickSubMenu">
                      <div class="text">{{ subitem.menu_disp_nm }}</div>
                      <div class="icon icons-right"></div>
                    </div>
                    <div class="sub-menu-wrap">
                      <ul class="sub-menu-list">
                        <li
                          v-for="leafitem in subitem.menu_list"
                          v-bind:key="leafitem.menu_id"
                          :data-div_cd="leafitem.menu_div_cd"
                          :data-pgmid="leafitem.pgm_id"
                          :data-pgmurl="leafitem.pgm_url"
                        >
                          <button
                            type="button"
                            class="btn"
                            @click="clickSubMenu"
                          >
                            <div class="text">
                              · {{ leafitem.menu_disp_nm }}
                            </div>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
              <!--//tabmenu1-->
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/*
 *  화면명   : 햄버그메뉴 Component
 *  화면ID   : MenuTab
 *  작성자   : 이상민
 *  수정이력 :
 *      20210310 최초작성
 */
import { mapState, mapActions } from "vuex";
import MenuTab from "./MenuTab.vue";

export default {
  data() {
    return {};
  },
  components: {
    MenuTab
  },
  computed: {
    ...mapState("manageUI", {
      isOpenMenu: state => state.isOpenMenu
    }),
    ...mapState("system", {
      menu_list: state => state.menu_data
    }),
    getMenuList() {
      let filtedMenuList = null;

      //채무자 신고 여부
      const dbtrRprObjtYn = this.$store.getters["customer/getConnInfo"](
        "dbtrRprObjtYn"
      );

      if (dbtrRprObjtYn == "N") {
        //채무자신고 대상이 아닐경우
        filtedMenuList = this.menu_list.filter(item => {
          return item.menu_id !== "020000";
        });

        this.menu_list.forEach(item => {
          if (item.menu_id == "010000") {
            item.class = "is-block";
            return;
          }
        });
      } else {
        filtedMenuList = this.menu_list;
      }

      return filtedMenuList;
    }
  },
  methods: {
    ...mapActions("manageUI", ["closeMenu"]),
    clickSubMenu(event) {
      event.preventDefault();
      const evtObj = $(event.target).closest("li");
      const data = evtObj.data();

      if (data.div_cd === "00") {
        if (evtObj.hasClass("has-sub")) {
          evtObj.toggleClass("active");
        }
      } else {
        if (data.div_cd === "01") {
          this.$go(data.pgmid);
          this.closeMenu();
        } else {
          this.$open(data.pgmurl);
        }
      }
    },
    getTabmenu(index) {
      return "tabmenu" + (index + 1);
    }
  }
};
</script>
